export default ($t) => ({
  title: "RaffleRegistration",
  type: "object",
  properties: {
    value: {
      title: "Active",
      type: "boolean",
      default: false,
    },
    min: {
      title: $t("edit_campaign.schema_raffle_registration_min", "Minimum ticket value"),
      type: "number",
      default: 1,
      description: $t("edit_campaign.schema_raffle_registration_min_description", {
        returnEmptyOnMissing: true,
      }),
    },
    max: {
      title: $t("edit_campaign.schema_raffle_registration_max", "Maximum ticket value"),
      type: "number",
      default: 360,
      description: $t("edit_campaign.schema_raffle_registration_max_description", {
        returnEmptyOnMissing: true,
      }),
    },
  },
});
